import React, { useState } from 'react';
import { Fade } from 'react-awesome-reveal';
import { Col, Row } from 'react-bootstrap';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import ConfigurableTable from 'components/shared/table/ConfigurableTable';
import {
  PAGINATION,
  SORT_BY,
  TABLE_NAME_STAKEHOLDER_ALERTS,
  STAKEHOLDER_ALERTS_COLUMNS,
  QUERY_KEY,
} from 'constants/constants';
import { getStakeholderAlertsData } from 'store/customer/customer-view-actions';
import { getRestrictedColumn } from 'utils/utils';
import LinkButton from 'components/shared/button/LinkButton';

const StakeholderAlerts = ({ onClose }) => {
  const { selectedCustomer, columnsRestiction } = useSelector(
    (state) => state?.CustomerView
  );
  const { roleId } = useSelector((state) => state.Auth.userClaimObject);
  const initialState = {
    values: [],
    offset: 0,
    totalSize: 0,
  };

  const defaultPageSize = 5;
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [sortBy, setSortBy] = useState({
    column: 'surveyResponseDate',
    order: SORT_BY.descend,
  });

  // Fetch stakeholder alerts data using React Query
  const { data: stakeholderAlertsData = initialState, isLoading } = useQuery({
    queryKey: [
      QUERY_KEY.StakeholderAlertsData,
      selectedCustomer?.value,
      roleId,
      sortBy,
      pageIndex,
      pageSize,
    ],
    queryFn: async () => {
      const offset = Math.ceil(pageIndex * pageSize - pageSize);
      const payload = {
        sortBy: sortBy.column,
        order: sortBy.order,
        limit: pageSize,
        offset,
        filterExpression: `Count({<Customer_Id={"${selectedCustomer?.value}"}, RoleId={"${roleId}"}>}distinct voc_surveyid)`,
      };
      const result = await getStakeholderAlertsData(payload);
      return result?.values?.length > 0 ? result : initialState;
    },
  });

  const pagination = {
    current: pageIndex,
    total: stakeholderAlertsData?.totalSize,
    pageSize: pageSize,
    pageSizeOptions: [5, ...PAGINATION.pageSizeOptions],
    showSizeChanger: true,
    disabledPageSizehandler: true,
  };

  const handleSorting = (column, order, pagination) => {
    let currentPageSize = pagination.pageSize;

    // Reset to first page if page size changes
    if (pageSize !== currentPageSize) {
      setPageIndex(1);
      setPageSize(currentPageSize);
    } else {
      setPageIndex(pagination.current);
    }

    setSortBy({ column, order: SORT_BY[order] });
  };

  return (
    <Fade cascade>
      <Row>
        <Col md={12}>
          <Spin spinning={isLoading}>
            <ConfigurableTable
              rows={stakeholderAlertsData?.values ?? []}
              columns={getRestrictedColumn(
                TABLE_NAME_STAKEHOLDER_ALERTS,
                STAKEHOLDER_ALERTS_COLUMNS,
                columnsRestiction
              ).map((col) => ({
                ...col,
                sortOrder:
                  sortBy.column === col.dataIndex
                    ? sortBy.order === SORT_BY.ascend
                      ? 'ascend'
                      : 'descend'
                    : null,
              }))}
              enableColumnSelection={false}
              enableExport={false}
              tableName={TABLE_NAME_STAKEHOLDER_ALERTS}
              pagination={pagination}
              isGlobalSort={true}
              onSort={handleSorting}
              dimentions={{ x: 1200, y: 500 }}
              customCss='custom-table gne-table'
            />
          </Spin>
        </Col>
        {/* Risk Driver Legend */}
        <div
          className='mb-3'
          style={
            stakeholderAlertsData?.values.length > 0
              ? { marginTop: '-3rem' }
              : {}
          }>
          <small className='title title__x-small title__bold'>
            <i className='icon icon__warning icon_box'></i>= Risk Driver
          </small>
        </div>
      </Row>
      <Row>
        <LinkButton
          className='text text__small justify-content-end pe-3 pt-3'
          onClick={onClose}>
          Close
        </LinkButton>
      </Row>
    </Fade>
  );
};

export default StakeholderAlerts;
